<div class="">
    <mat-slide-toggle
            [disabled]="type == 'generic'"
            (change)="onSlideChange($event)"
                      [checked]="item.value">
    </mat-slide-toggle>
    <label class="d-inline">
        <span class="mandatory">{{title ? title : type | translate}}</span>
    </label>
    <span>{{description | translate}}</span>
</div>
